import React from 'react'
import { Redirect, Route } from 'react-router-dom'

import usePermission from 'hooks/usePermission'
import constants from 'config/constants'
import { useSelector } from 'react-redux'
import * as R from 'ramda'
import useUser from 'hooks/useUser'

const PermissionRoute = ({
  component: Component,
  homePageUrl = '/dashboards/home/',
  permission = '',
  ...rest
}) => {
  const { hasPermission } = usePermission()
  const user = useUser()
  const storeHomePageUrl = useSelector((state) =>
    R.path(['pages', 'dashboard', 'homePageUrl'], state)
  )
  const redirectPath =
    user?.role === 'Billing' ? '/settings/billing/' : storeHomePageUrl || homePageUrl

  return (
    <Route
      {...rest}
      render={(props) => {
        if (hasPermission(permission)) {
          return <Component {...props} />
        } else {
          return (
            <Redirect
              to={{
                pathname: redirectPath,
                state: {
                  error: constants.permissionDeniedErrorMessage,
                },
              }}
            />
          )
        }
      }}
    />
  )
}
export default PermissionRoute



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/domains/routes/PermissionRoute/index.js